angular.module('core')
  .service('dblModalService', ['$modal', function($modal) {

    var openConfirmModal = function (args) {
        var modal = $modal.open({
            templateUrl: 'resources/core/partials/confirm-modal.html',
            windowClass: 'confirm-modal',
            controller: 'ConfirmModalController',
            backdrop: 'static',
            keyboard: false,
            resolve: {
                args: function() {
                    return args;
                }
            }
        });

        modal.args = args;

        return modal;
    };

    return {
        openConfirmModal: openConfirmModal
    };
}]);
